import { forwardRef, createElement } from 'react';

function IconChat(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20.313 12.156c.59.664.937 1.466.937 2.344 0 1.01-.467 1.944-1.272 2.68l-.21.179.885 1.77c.174.348.174.753.01 1.096l-.068.125-.084.118c-.352.44-.948.585-1.501.347l-.127-.062-.129-.09-2.446-1.955-.233.021-.19.012-.385.009c-2.065 0-3.908-.798-4.923-2.035a13.97 13.97 0 002.216-.108c.728.397 1.667.643 2.707.643.209 0 .415-.01.619-.03l.303-.037.323-.047 2.059 1.649-.969-1.94.582-.36c.86-.533 1.333-1.252 1.333-1.985 0-.371-.122-.733-.343-1.065.3-.336.562-.69.781-1.06l.125-.219zM11 3.25c4.786 0 8.75 2.725 8.75 6.25 0 3.455-3.81 6.143-8.47 6.247l-.139.001-4.662 3.73a1.25 1.25 0 01-1.567-.004l-.1-.09-.09-.102a1.25 1.25 0 01-.174-1.27l.06-.124 1.737-3.087-.23-.106c-2.193-1.046-3.646-2.768-3.842-4.737l-.017-.228-.006-.23c0-3.525 3.964-6.25 8.75-6.25zm0 1.5c-4.05 0-7.25 2.2-7.25 4.75 0 1.679 1.397 3.263 3.66 4.119l.255.092.85.293-1.969 3.498 4.072-3.255.267.002.384-.002c3.922-.095 6.981-2.253 6.981-4.747 0-2.55-3.2-4.75-7.25-4.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Chat = /*#__PURE__*/forwardRef(IconChat);

export default Chat;
//# sourceMappingURL=Chat.js.map
